import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    walletId: null,
    transactions: null,
    pendingTransactions: null,
    resolvedInactivations: [],
    unResolvedInactivations: [],
    isLicensed: null,
    fetchingLicenses: false,
  },
  getters: {
    getDriverTransactions: state => state.transactions,
    getDriverPendingTransactions: state => state.pendingTransactions,
    getWalletId: state => state.walletId,

    getResolvedInactivations: state => state.resolvedInactivations,
    getUnResolvedInactivations: state => state.unResolvedInactivations,
    getLicenseStatus: state => state.isLicensed,
    getFetchingLicensesStatus: state => state.fetchingLicenses,
  },
  mutations: {
    SET_WALLET_ID: (state, id) => {
      state.walletId = id
    },
    SET_TRANSACTIONS_LOADING: (state, status) => {
      state.transactionsLoading = status
    },
    SET_DRIVER_TRANSACTIONS: (state, transactions) => {
      state.transactions = transactions
    },
    SET_DRIVER_PENDING_TRANSACTIONS: (state, pendingTransactions) => {
      state.pendingTransactions = pendingTransactions
    },

    SET_RESOLVED_INACTIVATIONS(state, list) {
      state.resolvedInactivations = list
    },
    SET_UNRESOLVED_INACTIVATIONS(state, list) {
      state.unResolvedInactivations = list
    },
    SET_IS_LICENSED(state, status) {
      state.isLicensed = status
    },
    SET_FETCHING_LICENSES(state, status) {
      state.fetchingLicenses = status
    },
  },
  actions: {
    getCanceledDispatch(_, driverID) {
      return axiosIns.get(`dispatch/dispatchers/dispatch-messages/canceled/${driverID}`)
    },
    async fetchDriverLicense({ commit }, id) {
      commit('SET_FETCHING_LICENSES', true)
      const res = (await axiosIns.get(`drivers/${id}/licenses`)).data.data
      commit('SET_FETCHING_LICENSES', false)
      return res
    },
    createLicense(_, { id, licenseData }) {
      return axiosIns.post(`drivers/${id}/licenses`, licenseData)
    },
    deleteLicense(_, { licenseId }) {
      console.log('delete license', licenseId)
      return axiosIns.delete(`drivers/license/${licenseId}`)
    },
    updateLicense(_, { id, licenseData }) {
      return axiosIns.patch(`drivers/${id}/licenses`, licenseData)
    },
    async fetchDriverDevices(_, { id }) {
      return (await axiosIns.get(`drivers/${id}/devices`)).data.data
    },
    createDriverDeviceInfo(_, { id, deviceId, data }) {
      return axiosIns.post(`drivers/${id}/devices/${deviceId}`, data)
    },
    patchDriverDeviceInfo(_, { id, deviceId, data }) {
      return axiosIns.patch(`drivers/${id}/devices/${deviceId}`, data)
    },
    blockDriverDevice(_, { id, deviceId }) {
      return axiosIns.patch(`drivers/${id}/devices/${deviceId}/block`)
    },
    fetchDriverWallet(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`drivers/${id}/wallet`)
          .then(res => resolve(res.data.data))
          .catch(err => reject(err))
      })
    },
    async addDriverTransaction(ctx, { transaction, id }) {
      return new Promise((resolve, reject) => {
        axiosIns.post(`wallets/transactions/${id}`, transaction)
          .then(res => resolve(res))
          .catch(err => reject(err))
      })
    },
    async fetchDriverTransactions({ state, commit }, params = { page: 1, size: 10 }) {
      try {
        commit('SET_DRIVER_TRANSACTIONS', null)
        const transactions = await axiosIns.get(`wallets/${state.walletId}/transactions`, {
          params,
        })
        commit('SET_DRIVER_TRANSACTIONS', transactions.data.data)
      } catch (err) {
        console.log(err)
      }
    },
    async fetchDriverPendingTransactions({ state, commit }, params = { page: 1, size: 10 }) {
      try {
        commit('SET_DRIVER_PENDING_TRANSACTIONS', null)
        const pendingTransactions = await axiosIns.get(`wallets/${state.walletId}/pending-transactions`, {
          params,
        })
        commit('SET_DRIVER_PENDING_TRANSACTIONS', pendingTransactions.data.data)
      } catch (err) {
        console.log(err)
      }
    },
    updateDriverWallet(ctx, { walletId, walletInfo }) {
      return new Promise((resolve, reject) => {
        axiosIns.patch(`drivers/wallets/${walletId}`, walletInfo)
          .then(res => resolve(res.data.data))
          .catch(err => reject(err))
      })
    },

    async createDriverInactivation(ctx, inactivation) {
      try {
        await axiosIns.post('drivers/inactivations', inactivation)
      } catch (error) {
        console.log(error)
      }
    },
    async resolveDriverInactivation(ctx, { inactivationId }) {
      const loggedUser = JSON.parse(localStorage.getItem('userData'))
      try {
        await axiosIns.patch(`drivers/inactivations/${inactivationId}`, {
          isResolved: true,
          solvedBy: loggedUser.email,
        })
      } catch (error) {
        console.log(error)
      }
    },
    async fetchDriverInactivationList({ commit }, { id, isResolvedInactivation }) {
      try {
        if (isResolvedInactivation) {
          commit('SET_RESOLVED_INACTIVATIONS', [])
        } else {
          commit('SET_UNRESOLVED_INACTIVATIONS', [])
        }
        const inactivationList = await axiosIns.get(`/drivers/${id}/inactivations`, {
          params: {
            isResolvedInactivation,
          },
        })
        if (isResolvedInactivation) {
          commit('SET_RESOLVED_INACTIVATIONS', inactivationList.data.data)
        } else {
          commit('SET_UNRESOLVED_INACTIVATIONS', inactivationList.data.data)
        }
      } catch (error) {
        console.log(error)
      }
    },
    fetchDispatchStatistics(ctx, id) {
      return axiosIns.get(`/dispatch/dispatchers/statistics/${id}`)
    },
    fetchDriverStatusHistory(ctx, id) {
      return axiosIns.get(`/drivers/availability/history/${id}`)
    },
    fetchDriverStateStatistics(ctx, dd) {
      return axiosIns.get(`/drivers/availability/${dd.id}`, {
        params: {
          from: dd.from,
        },
      })
    },
    reverseTransaction(ctx, id) {
      const user = JSON.parse(localStorage.getItem('userData'))
      return axiosIns.post(`/transactions/reverse/${id}`, {
        added_by: user.email,
      })
    },
    resetDriverAcceptanceRate(_, id) {
      return axiosIns.delete(`dispatch/dispatchers/dispatch-messages/clear-by-user-id/${id}`)
    },
  },
}
